import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export function getWorldCupInviteWaitingRoomStyles(theme: Theme) {
  return StyleSheet.create({
    loadingContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 20,
      paddingTop: Platform.OS === 'web' ? 40 : 60,
    },
    loadingText: {
      color: theme.white,
      marginTop: 16,
      fontSize: 16,
      fontWeight: '500',
    },
    errorTitle: {
      fontSize: 22,
      fontWeight: '700',
      color: theme.white,
      marginBottom: 8,
      textAlign: 'center',
    },
    errorMessage: {
      color: theme.white,
      textAlign: 'center',
      marginBottom: 24,
    },
    primaryButton: {
      paddingHorizontal: 32,
      paddingVertical: 14,
      borderRadius: 12,
      backgroundColor: theme.white,
      alignItems: 'center',
    },
    primaryButtonText: {
      color: theme.primary,
      fontSize: 16,
      fontWeight: '700',
    },
    pressed: {
      opacity: 0.85,
    },
  });
}
